// extracted by mini-css-extract-plugin
module.exports = {"footerSection":"footer-section_footerSection__ikh8I"};